import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

import { EventContentTab } from "@features/offer/shared/event";
import { ProviderNameEnum } from "@gp/models";
import { EventContext } from "@gp/components";

export const FullStatisticsButton = observer(
	function FullStatisticsButton(props: {
		store: EventViewStore | AdditionalOfferViewStore;
	}) {
		const { t } = useTranslation();

		const event = useContext(EventContext);

		const isBREvent =
			event?.source?.providerName == ProviderNameEnum.BetRadar
				? true
				: false;
		const betRadarId = isBREvent ? event.source?.matchId : null;

		return (
			<EventContentTab
				textContent={t("EVENT.HEADER.FULL_STATS")}
				isActive={
					props.store.displayStatisticsGroup ===
					StatisticsGroups.FullStats
				}
				disabled={!betRadarId}
				onClick={() => {
					props.store.setDisplayStatisticsGroup(
						StatisticsGroups.FullStats
					);
				}}
			/>
		);
	}
);
